import React, { useContext } from "react";
import {
  Link
} from "react-router-dom";
import { SettingsContext } from 'Providers/SettingsProvider';

const SlugLink = React.forwardRef(({ item, children, className, forwardedRef, onMouseEnter }, ref) => {
  const { getPath, pathname } = useContext(SettingsContext);
  const path=item.absolutePath ? item.absolutePath : getPath(item);
  return <Link to={{pathname:path,state:{from:pathname}}} className={className} ref={ref || forwardedRef} onMouseEnter={onMouseEnter}>{children}</Link>;
});

export default SlugLink;
